__turbopack_context__.v({
  "className": "josefin_sans_1854e469-module__a-D6Ya__className",
  "variable": "josefin_sans_1854e469-module__a-D6Ya__variable",
});
